import _classCallCheck from "/var/lib/jenkins/jobs/EV/jobs/NextJS/jobs/02-cert-build/workspace/target/checkout/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/var/lib/jenkins/jobs/EV/jobs/NextJS/jobs/02-cert-build/workspace/target/checkout/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
/*
 * EV User Retrieval API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.44
 *
 * Do not edit the class manually.
 *
 */
import { ApiClient } from "../ApiClient";
import { IQueryRefinement } from "./IQueryRefinement";
import { SearchHistoryDedupCriteria } from "./SearchHistoryDedupCriteria";
import { SortOption } from "./SortOption";

/**
 * The SearchesEntityBean model module.
 * @module modelrest/SearchesEntityBean
 * @version 1.0
 */
export var SearchesEntityBean = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>SearchesEntityBean</code>.
   * @alias module:modelrest/SearchesEntityBean
   * @class
   */
  function SearchesEntityBean() {
    _classCallCheck(this, SearchesEntityBean);
  }

  /**
   * Constructs a <code>SearchesEntityBean</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:modelrest/SearchesEntityBean} obj Optional instance to populate.
   * @return {module:modelrest/SearchesEntityBean} The populated <code>SearchesEntityBean</code> instance.
   */
  _createClass(SearchesEntityBean, null, [{
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new SearchesEntityBean();
        if (data.hasOwnProperty("database")) obj.database = ApiClient.convertToType(data["database"], ["String"]);
        if (data.hasOwnProperty("databasemask")) obj.databasemask = ApiClient.convertToType(data["databasemask"], "String");
        if (data.hasOwnProperty("searchId")) obj.searchId = ApiClient.convertToType(data["searchId"], "String");
        if (data.hasOwnProperty("searchtype")) obj.searchtype = ApiClient.convertToType(data["searchtype"], "String");
        if (data.hasOwnProperty("emailalertweek")) obj.emailalertweek = ApiClient.convertToType(data["emailalertweek"], "String");
        if (data.hasOwnProperty("language")) obj.language = ApiClient.convertToType(data["language"], "String");
        if (data.hasOwnProperty("startYear")) obj.startYear = ApiClient.convertToType(data["startYear"], "String");
        if (data.hasOwnProperty("endYear")) obj.endYear = ApiClient.convertToType(data["endYear"], "String");
        if (data.hasOwnProperty("autostem")) obj.autostem = ApiClient.convertToType(data["autostem"], "String");
        if (data.hasOwnProperty("sort")) obj.sort = ApiClient.convertToType(data["sort"], "String");
        if (data.hasOwnProperty("sortdir")) obj.sortdir = ApiClient.convertToType(data["sortdir"], "String");
        if (data.hasOwnProperty("documenttype")) obj.documenttype = ApiClient.convertToType(data["documenttype"], "String");
        if (data.hasOwnProperty("treatmentType")) obj.treatmentType = ApiClient.convertToType(data["treatmentType"], "String");
        if (data.hasOwnProperty("disciplinetype")) obj.disciplinetype = ApiClient.convertToType(data["disciplinetype"], "String");
        if (data.hasOwnProperty("updatesNo")) obj.updatesNo = ApiClient.convertToType(data["updatesNo"], "String");
        if (data.hasOwnProperty("searchWord1")) obj.searchWord1 = ApiClient.convertToType(data["searchWord1"], "String");
        if (data.hasOwnProperty("searchWord2")) obj.searchWord2 = ApiClient.convertToType(data["searchWord2"], "String");
        if (data.hasOwnProperty("searchWord3")) obj.searchWord3 = ApiClient.convertToType(data["searchWord3"], "String");
        if (data.hasOwnProperty("searchphrases")) obj.searchphrases = ApiClient.convertToType(data["searchphrases"], "String");
        if (data.hasOwnProperty("searchWords")) obj.searchWords = ApiClient.convertToType(data["searchWords"], ["String"]);
        if (data.hasOwnProperty("section1")) obj.section1 = ApiClient.convertToType(data["section1"], "String");
        if (data.hasOwnProperty("section2")) obj.section2 = ApiClient.convertToType(data["section2"], "String");
        if (data.hasOwnProperty("section3")) obj.section3 = ApiClient.convertToType(data["section3"], "String");
        if (data.hasOwnProperty("sectionStr")) obj.sectionStr = ApiClient.convertToType(data["sectionStr"], "String");
        if (data.hasOwnProperty("sections")) obj.sections = ApiClient.convertToType(data["sections"], ["String"]);
        if (data.hasOwnProperty("boolean1")) obj.boolean1 = ApiClient.convertToType(data["boolean1"], "String");
        if (data.hasOwnProperty("boolean2")) obj.boolean2 = ApiClient.convertToType(data["boolean2"], "String");
        if (data.hasOwnProperty("booleansStr")) obj.booleansStr = ApiClient.convertToType(data["booleansStr"], "String");
        if (data.hasOwnProperty("booleans")) obj.booleans = ApiClient.convertToType(data["booleans"], ["String"]);
        if (data.hasOwnProperty("dataFormat")) obj.dataFormat = ApiClient.convertToType(data["dataFormat"], "String");
        if (data.hasOwnProperty("pageSize")) obj.pageSize = ApiClient.convertToType(data["pageSize"], "Number");
        if (data.hasOwnProperty("getxQuery")) obj.getxQuery = ApiClient.convertToType(data["getxQuery"], "String");
        if (data.hasOwnProperty("includeOutputKeys")) obj.includeOutputKeys = ApiClient.convertToType(data["includeOutputKeys"], "Boolean");
        if (data.hasOwnProperty("alertAUID")) obj.alertAUID = ApiClient.convertToType(data["alertAUID"], "String");
        if (data.hasOwnProperty("sortOption")) obj.sortOption = SortOption.constructFromObject(data["sortOption"]);
        if (data.hasOwnProperty("navDataCount")) obj.navDataCount = ApiClient.convertToType(data["navDataCount"], "Number");
        if (data.hasOwnProperty("queryRefinement")) obj.queryRefinement = IQueryRefinement.constructFromObject(data["queryRefinement"]);
        if (data.hasOwnProperty("refineSearch")) obj.refineSearch = ApiClient.convertToType(data["refineSearch"], "Boolean");
        if (data.hasOwnProperty("alertLatest")) obj.alertLatest = ApiClient.convertToType(data["alertLatest"], "String");
        if (data.hasOwnProperty("refinestack")) obj.refinestack = ApiClient.convertToType(data["refinestack"], "String");
        if (data.hasOwnProperty("fetchNavigator")) obj.fetchNavigator = ApiClient.convertToType(data["fetchNavigator"], "Boolean");
        if (data.hasOwnProperty("highlightingEnabled")) obj.highlightingEnabled = ApiClient.convertToType(data["highlightingEnabled"], "Boolean");
        if (data.hasOwnProperty("sessionId")) obj.sessionId = ApiClient.convertToType(data["sessionId"], "String");
        if (data.hasOwnProperty("alldb")) obj.alldb = ApiClient.convertToType(data["alldb"], "String");
        if (data.hasOwnProperty("yearrange")) obj.yearrange = ApiClient.convertToType(data["yearrange"], "String");
        if (data.hasOwnProperty("yearselect")) obj.yearselect = ApiClient.convertToType(data["yearselect"], "String");
        if (data.hasOwnProperty("userid")) obj.userid = ApiClient.convertToType(data["userid"], "String");
        if (data.hasOwnProperty("userEmail")) obj.userEmail = ApiClient.convertToType(data["userEmail"], "String");
        if (data.hasOwnProperty("savedate")) obj.savedate = ApiClient.convertToType(data["savedate"], "Date");
        if (data.hasOwnProperty("accessdate")) obj.accessdate = ApiClient.convertToType(data["accessdate"], "Date");
        if (data.hasOwnProperty("emailalert")) obj.emailalert = ApiClient.convertToType(data["emailalert"], "String");
        if (data.hasOwnProperty("saved")) obj.saved = ApiClient.convertToType(data["saved"], "String");
        if (data.hasOwnProperty("visible")) obj.visible = ApiClient.convertToType(data["visible"], "String");
        if (data.hasOwnProperty("resultscount")) obj.resultscount = ApiClient.convertToType(data["resultscount"], "String");
        if (data.hasOwnProperty("subcounts")) obj.subcounts = ApiClient.convertToType(data["subcounts"], "String");
        if (data.hasOwnProperty("displayquery")) obj.displayquery = ApiClient.convertToType(data["displayquery"], "String");
        if (data.hasOwnProperty("intermediatequery")) obj.intermediatequery = ApiClient.convertToType(data["intermediatequery"], "String");
        if (data.hasOwnProperty("dupset")) obj.dupset = ApiClient.convertToType(data["dupset"], "String");
        if (data.hasOwnProperty("dedup")) obj.dedup = ApiClient.convertToType(data["dedup"], "String");
        if (data.hasOwnProperty("dedupdb")) obj.dedupdb = ApiClient.convertToType(data["dedupdb"], "String");
        if (data.hasOwnProperty("resultsstate")) obj.resultsstate = ApiClient.convertToType(data["resultsstate"], "String");
        if (data.hasOwnProperty("rfrxcolls")) obj.rfrxcolls = ApiClient.convertToType(data["rfrxcolls"], "String");
        if (data.hasOwnProperty("alertDisabled")) obj.alertDisabled = ApiClient.convertToType(data["alertDisabled"], "String");
        if (data.hasOwnProperty("userDatabasemask")) obj.userDatabasemask = ApiClient.convertToType(data["userDatabasemask"], "Number");
        if (data.hasOwnProperty("searchName")) obj.searchName = ApiClient.convertToType(data["searchName"], "String");
        if (data.hasOwnProperty("downloadFormat")) obj.downloadFormat = ApiClient.convertToType(data["downloadFormat"], "String");
        if (data.hasOwnProperty("documentView")) obj.documentView = ApiClient.convertToType(data["documentView"], "String");
        if (data.hasOwnProperty("bulletinLocation")) obj.bulletinLocation = ApiClient.convertToType(data["bulletinLocation"], "String");
        if (data.hasOwnProperty("coverPageLocation")) obj.coverPageLocation = ApiClient.convertToType(data["coverPageLocation"], "String");
        if (data.hasOwnProperty("bulletinCreationDate")) obj.bulletinCreationDate = ApiClient.convertToType(data["bulletinCreationDate"], "Date");
        if (data.hasOwnProperty("dedupCriterias")) obj.dedupCriterias = ApiClient.convertToType(data["dedupCriterias"], [SearchHistoryDedupCriteria]);
        if (data.hasOwnProperty("physicalQuery")) obj.physicalQuery = ApiClient.convertToType(data["physicalQuery"], "String");
        if (data.hasOwnProperty("databasedisplay")) obj.databasedisplay = ApiClient.convertToType(data["databasedisplay"], "String");
        if (data.hasOwnProperty("alertOwner")) obj.alertOwner = ApiClient.convertToType(data["alertOwner"], "Boolean");
        if (data.hasOwnProperty("serialnumber")) obj.serialnumber = ApiClient.convertToType(data["serialnumber"], "Number");
        if (data.hasOwnProperty("cclist")) obj.cclist = ApiClient.convertToType(data["cclist"], "String");
        if (data.hasOwnProperty("searchHistoryRecording")) obj.searchHistoryRecording = ApiClient.convertToType(data["searchHistoryRecording"], "Boolean");
        if (data.hasOwnProperty("resultsCountWithCommas")) obj.resultsCountWithCommas = ApiClient.convertToType(data["resultsCountWithCommas"], "String");
        if (data.hasOwnProperty("offset")) obj.offset = ApiClient.convertToType(data["offset"], "Number");
      }
      return obj;
    }
  }]);
  return SearchesEntityBean;
}();

/**
 * @member {Array.<String>} database
 */
SearchesEntityBean.prototype.database = undefined;

/**
 * @member {String} databasemask
 */
SearchesEntityBean.prototype.databasemask = undefined;

/**
 * @member {String} searchId
 */
SearchesEntityBean.prototype.searchId = undefined;

/**
 * @member {String} searchtype
 */
SearchesEntityBean.prototype.searchtype = undefined;

/**
 * @member {String} emailalertweek
 */
SearchesEntityBean.prototype.emailalertweek = undefined;

/**
 * @member {String} language
 */
SearchesEntityBean.prototype.language = undefined;

/**
 * @member {String} startYear
 */
SearchesEntityBean.prototype.startYear = undefined;

/**
 * @member {String} endYear
 */
SearchesEntityBean.prototype.endYear = undefined;

/**
 * @member {String} autostem
 */
SearchesEntityBean.prototype.autostem = undefined;

/**
 * @member {String} sort
 */
SearchesEntityBean.prototype.sort = undefined;

/**
 * @member {String} sortdir
 */
SearchesEntityBean.prototype.sortdir = undefined;

/**
 * @member {String} documenttype
 */
SearchesEntityBean.prototype.documenttype = undefined;

/**
 * @member {String} treatmentType
 */
SearchesEntityBean.prototype.treatmentType = undefined;

/**
 * @member {String} disciplinetype
 */
SearchesEntityBean.prototype.disciplinetype = undefined;

/**
 * @member {String} updatesNo
 */
SearchesEntityBean.prototype.updatesNo = undefined;

/**
 * @member {String} searchWord1
 */
SearchesEntityBean.prototype.searchWord1 = undefined;

/**
 * @member {String} searchWord2
 */
SearchesEntityBean.prototype.searchWord2 = undefined;

/**
 * @member {String} searchWord3
 */
SearchesEntityBean.prototype.searchWord3 = undefined;

/**
 * @member {String} searchphrases
 */
SearchesEntityBean.prototype.searchphrases = undefined;

/**
 * @member {Array.<String>} searchWords
 */
SearchesEntityBean.prototype.searchWords = undefined;

/**
 * @member {String} section1
 */
SearchesEntityBean.prototype.section1 = undefined;

/**
 * @member {String} section2
 */
SearchesEntityBean.prototype.section2 = undefined;

/**
 * @member {String} section3
 */
SearchesEntityBean.prototype.section3 = undefined;

/**
 * @member {String} sectionStr
 */
SearchesEntityBean.prototype.sectionStr = undefined;

/**
 * @member {Array.<String>} sections
 */
SearchesEntityBean.prototype.sections = undefined;

/**
 * @member {String} boolean1
 */
SearchesEntityBean.prototype.boolean1 = undefined;

/**
 * @member {String} boolean2
 */
SearchesEntityBean.prototype.boolean2 = undefined;

/**
 * @member {String} booleansStr
 */
SearchesEntityBean.prototype.booleansStr = undefined;

/**
 * @member {Array.<String>} booleans
 */
SearchesEntityBean.prototype.booleans = undefined;

/**
 * @member {String} dataFormat
 */
SearchesEntityBean.prototype.dataFormat = undefined;

/**
 * @member {Number} pageSize
 */
SearchesEntityBean.prototype.pageSize = undefined;

/**
 * @member {String} getxQuery
 */
SearchesEntityBean.prototype.getxQuery = undefined;

/**
 * @member {Boolean} includeOutputKeys
 */
SearchesEntityBean.prototype.includeOutputKeys = undefined;

/**
 * @member {String} alertAUID
 */
SearchesEntityBean.prototype.alertAUID = undefined;

/**
 * @member {module:modelrest/SortOption} sortOption
 */
SearchesEntityBean.prototype.sortOption = undefined;

/**
 * @member {Number} navDataCount
 */
SearchesEntityBean.prototype.navDataCount = undefined;

/**
 * @member {module:modelrest/IQueryRefinement} queryRefinement
 */
SearchesEntityBean.prototype.queryRefinement = undefined;

/**
 * @member {Boolean} refineSearch
 */
SearchesEntityBean.prototype.refineSearch = undefined;

/**
 * @member {String} alertLatest
 */
SearchesEntityBean.prototype.alertLatest = undefined;

/**
 * @member {String} refinestack
 */
SearchesEntityBean.prototype.refinestack = undefined;

/**
 * @member {Boolean} fetchNavigator
 */
SearchesEntityBean.prototype.fetchNavigator = undefined;

/**
 * @member {Boolean} highlightingEnabled
 */
SearchesEntityBean.prototype.highlightingEnabled = undefined;

/**
 * @member {String} sessionId
 */
SearchesEntityBean.prototype.sessionId = undefined;

/**
 * @member {String} alldb
 */
SearchesEntityBean.prototype.alldb = undefined;

/**
 * @member {String} yearrange
 */
SearchesEntityBean.prototype.yearrange = undefined;

/**
 * @member {String} yearselect
 */
SearchesEntityBean.prototype.yearselect = undefined;

/**
 * @member {String} userid
 */
SearchesEntityBean.prototype.userid = undefined;

/**
 * @member {String} userEmail
 */
SearchesEntityBean.prototype.userEmail = undefined;

/**
 * @member {Date} savedate
 */
SearchesEntityBean.prototype.savedate = undefined;

/**
 * @member {Date} accessdate
 */
SearchesEntityBean.prototype.accessdate = undefined;

/**
 * @member {String} emailalert
 */
SearchesEntityBean.prototype.emailalert = undefined;

/**
 * @member {String} saved
 */
SearchesEntityBean.prototype.saved = undefined;

/**
 * @member {String} visible
 */
SearchesEntityBean.prototype.visible = undefined;

/**
 * @member {String} resultscount
 */
SearchesEntityBean.prototype.resultscount = undefined;

/**
 * @member {String} subcounts
 */
SearchesEntityBean.prototype.subcounts = undefined;

/**
 * @member {String} displayquery
 */
SearchesEntityBean.prototype.displayquery = undefined;

/**
 * @member {String} intermediatequery
 */
SearchesEntityBean.prototype.intermediatequery = undefined;

/**
 * @member {String} dupset
 */
SearchesEntityBean.prototype.dupset = undefined;

/**
 * @member {String} dedup
 */
SearchesEntityBean.prototype.dedup = undefined;

/**
 * @member {String} dedupdb
 */
SearchesEntityBean.prototype.dedupdb = undefined;

/**
 * @member {String} resultsstate
 */
SearchesEntityBean.prototype.resultsstate = undefined;

/**
 * @member {String} rfrxcolls
 */
SearchesEntityBean.prototype.rfrxcolls = undefined;

/**
 * @member {String} alertDisabled
 */
SearchesEntityBean.prototype.alertDisabled = undefined;

/**
 * @member {Number} userDatabasemask
 */
SearchesEntityBean.prototype.userDatabasemask = undefined;

/**
 * @member {String} searchName
 */
SearchesEntityBean.prototype.searchName = undefined;

/**
 * @member {String} downloadFormat
 */
SearchesEntityBean.prototype.downloadFormat = undefined;

/**
 * @member {String} documentView
 */
SearchesEntityBean.prototype.documentView = undefined;

/**
 * @member {String} bulletinLocation
 */
SearchesEntityBean.prototype.bulletinLocation = undefined;

/**
 * @member {String} coverPageLocation
 */
SearchesEntityBean.prototype.coverPageLocation = undefined;

/**
 * @member {Date} bulletinCreationDate
 */
SearchesEntityBean.prototype.bulletinCreationDate = undefined;

/**
 * @member {Array.<module:modelrest/SearchHistoryDedupCriteria>} dedupCriterias
 */
SearchesEntityBean.prototype.dedupCriterias = undefined;

/**
 * @member {String} physicalQuery
 */
SearchesEntityBean.prototype.physicalQuery = undefined;

/**
 * @member {String} databasedisplay
 */
SearchesEntityBean.prototype.databasedisplay = undefined;

/**
 * @member {Boolean} alertOwner
 */
SearchesEntityBean.prototype.alertOwner = undefined;

/**
 * @member {Number} serialnumber
 */
SearchesEntityBean.prototype.serialnumber = undefined;

/**
 * @member {String} cclist
 */
SearchesEntityBean.prototype.cclist = undefined;

/**
 * @member {Boolean} searchHistoryRecording
 */
SearchesEntityBean.prototype.searchHistoryRecording = undefined;

/**
 * @member {String} resultsCountWithCommas
 */
SearchesEntityBean.prototype.resultsCountWithCommas = undefined;

/**
 * @member {Number} offset
 */
SearchesEntityBean.prototype.offset = undefined;